import { Dimensions, View } from "react-native";
import styled from "styled-components";
import SegmentsTab from "./SegmentsTab";
import * as React from "react";
import { useRouter } from "../utils/router";

type VendorType =
  | "Market Vendor"
  | "Farmer"
  | "Service Provider"
  | "Other Vendor";
type Tab =
  | "Onboarding"
  | "TOS"
  | "Privacy Policy"
  | VendorType
  | "Export Products"
  | "Export Services";
const leftTabs: Tab[] = [
  "Onboarding",
  "TOS",
  "Privacy Policy",
  "Export Products",
  "Export Services"
];

const vendorTypes: VendorType[] = [
  "Market Vendor",
  "Farmer",
  "Service Provider",
  "Other Vendor"
];

export const Header = (props: { selected: Tab }) => {
  const vertical = Dimensions.get("window").width > 700;
  const { history } = useRouter();
  return (
    <Header.Container vertical={vertical}>
      <SegmentsTab
        tabs={[...leftTabs, " ", ...vendorTypes]}
        selected={props.selected}
        onSelect={(tab: Tab) => {
          if (tab === props.selected) {
            return;
          }
          if (vendorTypes.includes(tab as VendorType)) {
            history.replace(`/vendor/${tab}`);
            return;
          }
          const routeMap = {
            Onboarding: "/onboardingQuestions",
            TOS: "/editTOS",
            "Privacy Policy": "/editPrivacyPolicy",
            "Export Products": "/export/products",
            "Export Services": "/export/services"
          };
          // @ts-ignore
          history.replace(routeMap[tab]);
        }}
      />
    </Header.Container>
  );
};

Header.Container = styled(View)<{ vertical: boolean }>`
  height: ${props => (props.vertical ? 60 : 44)}px;
  background-color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  justify-content: center;
`;

export const Bottom = styled(View)`
  flex-direction: row;
  height: 70px;
  justify-content: center;
  align-items: center;
  background-color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
`;

export const Content = styled(View)`
  flex: 1;
  padding: 20px;
`;
